var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"radio-group"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"radio-group-item",class:{
      active: option.value === _vm.value
    },on:{"click":function($event){return _vm.handleClick(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }